import { IApplicationState } from '../../types/redux';
import { getNewbuildingFlightEntryUrl } from './getNewbuildingFlightEntryUrl';

export const getNewbuildingFlightBannerAvailable = (state: IApplicationState) => {
  return Boolean(getNewbuildingFlightEntryUrl(state));
};
